import { Box, Button, Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PageHeaderLayout from "../../components/Layout/PageHeaderLayout";
import { useNavigate } from "react-router-dom";
import ChatList from "./ChatList";
import ChatDetails from "./ChatBox";

export default function CudelChats() {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'chats'
        });
    }, []);
    const navigate = useNavigate();
    const [selectedBookingId, setSelectedBookingId] = useState(null);
    return (
        <>
            <PageHeaderLayout headerTitle={"Cudel Chats"} >
                <Button variant='contained' size='small' 
                    onClick={()=>navigate(-1)} 
                    sx={{ marginTop: "10px", marginRight: "10px",textTransform:"capitalize" }}
                >
                    back
                </Button>
            </PageHeaderLayout>
            <Grid container spacing={2} sx={{height:'82.5vh'}}>
                <Grid item xs={4} sx={{height:'100%'}}>
                    <ChatList setSelectedBookingId={setSelectedBookingId} selectedBookingId={selectedBookingId}/>
                </Grid>
                
                <Grid item xs={8} sx={{height:'100%'}}>
                    {selectedBookingId ? 
                    <ChatDetails bookingId={selectedBookingId} />
                    :
                    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
                            <Typography variant="h6" color="textSecondary">
                                No Booking is Selected...Select a booking to view details
                            </Typography>
                        </Box>
                    </Card>
                    }
                </Grid>
            </Grid>
        </>
        
    )
}
